import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { CLIENT_GSERVICE_URL } from 'src/constants';

const WidgetExchangeStat = () => {
  const [dataExchange, setDataExchange] = useState(null);

  const fetchData = async () => {
    const res = await fetch(`${CLIENT_GSERVICE_URL}/exchange`);
    const resJson = await res.json();
    setDataExchange(resJson);
  };

  useEffect(() => {
    fetchData();
  }, []);

  let newData = [];
  let dataUpdate = null;
  if (dataExchange !== null) {
    newData = Object.values(dataExchange).slice(0, 6);
    dataUpdate = dayjs(dataExchange?.datetime).locale('th').format('DD MMM BBBB เวลา H:mm น.');
  }

  return (
    <div className='widget-exchange-stat'>
      {dataExchange !== null && (
        <>
          <h2>อัตราแลกเปลี่ยน</h2>
          <div className='widget-exchange-stat-box'>
            {newData.map(data => (
              <ul>
                {[...data].map(item => (
                  <li>{item}</li>
                ))}
              </ul>
            ))}
          </div>
          <p className='date-update'>อัพเดท {dataUpdate}</p>
        </>
      )}
    </div>
  );
};

export default WidgetExchangeStat;
